import React from 'react';


export  const Loader = () => {
  return (

       <div className="flex justify-center items-center h-screen">
      <svg className="w-24 h-24" viewBox="0 0 240 240">
        <circle className="pl__ring pl__ring--a stroke-red-500" cx={120} cy={120} r={105} fill="none" strokeWidth={20} strokeDasharray="0 660" strokeDashoffset={-330} strokeLinecap="round" />
        <circle className="pl__ring pl__ring--b stroke-orange-500" cx={120} cy={120} r={35} fill="none" strokeWidth={20} strokeDasharray="0 220" strokeDashoffset={-110} strokeLinecap="round" />
        <circle className="pl__ring pl__ring--c stroke-blue-500" cx={85} cy={120} r={70} fill="none" strokeWidth={20} strokeDasharray="0 440" strokeLinecap="round" />
        <circle className="pl__ring pl__ring--d stroke-pink-500" cx={155} cy={120} r={70} fill="none" strokeWidth={20} strokeDasharray="0 440" strokeLinecap="round" />
      </svg>
    </div>


  );
};


